import { makeStyles } from "@material-ui/core"
import { themeColors } from "letalkui"

const { gray, purple, beige, blue, green, yellow, red } = themeColors.colors.system

const useStyles = makeStyles({
	dialogContent: {
		overflowY: "hidden"
	},
	quotedMessage: {
		padding: "12px 16px",
		borderRadius: 12,
		borderLeft: `4px solid ${purple[600]}`,
		backgroundColor: beige[50]
	},
	quotedMessageMeta: {
		color: purple[600],
		fontWeight: 600
	},
	quotedMessageText: {
		display: "-webkit-box",
		overflow: "hidden",
		wordBreak: "break-word",
		WebkitLineClamp: 2,
		WebkitBoxOrient: "vertical",
		color: gray[800]
	},
	searchInput: {
		borderRadius: 24,
		backgroundColor: gray[50]
	},
	searchIcon: {
		color: gray[500]
	},
	targetsScrollArea: {
		maxHeight: "calc(100vh - 420px)",
		minHeight: 160,
		overflowY: "auto"
	},
	targetsScrollAreaWithSelection: {
		maxHeight: "calc(100vh - 470px)"
	},
	targetsScrollAreaWithSelectionAndBanner: {
		maxHeight: "calc(100vh - 525px)"
	},
	sectionTitle: {
		display: "block",
		fontSize: 11,
		fontWeight: 700,
		letterSpacing: 1,
		color: gray[500],
		padding: "12px 0 8px"
	},
	recentGrid: {
		display: "flex",
		flexWrap: "wrap",
		gap: 8
	},
	recentItem: {
		width: 84,
		padding: "6px 2px",
		borderRadius: 12,
		cursor: "pointer",
		textAlign: "center",
		"&:hover": {
			backgroundColor: gray[50]
		}
	},
	recentItemDisabled: {
		opacity: 0.45,
		cursor: "not-allowed"
	},
	recentAvatarWrapper: {
		position: "relative",
		width: 56,
		height: 56,
		margin: "0 auto 6px"
	},
	recentAvatar: {
		width: 56,
		height: 56,
		fontSize: 18,
		fontWeight: 600
	},
	recentAvatarSelected: {
		boxShadow: `0 0 0 2px ${themeColors.colors.base.white}, 0 0 0 4px ${purple[600]}`
	},
	recentCornerBadge: {
		position: "absolute",
		bottom: -2,
		width: 20,
		height: 20,
		borderRadius: "50%",
		color: themeColors.colors.base.white,
		border: `2px solid ${themeColors.colors.base.white}`,
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		"& svg": {
			fontSize: 12
		}
	},
	recentCheckBadge: {
		right: -2,
		backgroundColor: purple[600]
	},
	recentName: {
		fontSize: 12,
		lineHeight: "15px",
		color: gray[800]
	},
	recentLockBadge: {
		left: -2,
		backgroundColor: gray[600]
	},
	newAttendanceChip: {
		backgroundColor: blue[50],
		color: blue[800],
		border: `1px solid ${blue[100]}`,
		"& svg": {
			color: blue[600]
		}
	},
	selectedStrip: {
		gap: 6,
		overflow: "hidden"
	},
	selectedChip: {
		maxWidth: 150,
		flexShrink: 0,
		backgroundColor: purple[50],
		color: purple[800],
		border: `1px solid ${purple[100]}`
	},
	selectedChipAvatar: {
		width: 20,
		height: 20,
		fontSize: 10
	},
	selectedMoreChip: {
		flexShrink: 0,
		backgroundColor: gray[100],
		color: gray[700]
	},
	newAttendanceBanner: {
		gap: 8,
		padding: "8px 12px",
		borderRadius: 8,
		backgroundColor: blue[50],
		color: blue[800]
	},
	newAttendanceBannerIcon: {
		fontSize: 18,
		color: blue[600]
	},
	targetRow: {
		borderRadius: 10,
		paddingTop: 8,
		paddingBottom: 8
	},
	avatar: {
		width: 40,
		height: 40,
		fontSize: 15,
		fontWeight: 600
	},
	avatarPurple: {
		backgroundColor: purple[100],
		color: purple[800]
	},
	avatarBlue: {
		backgroundColor: blue[100],
		color: blue[800]
	},
	avatarGreen: {
		backgroundColor: green[100],
		color: green[800]
	},
	avatarYellow: {
		backgroundColor: yellow[100],
		color: yellow[800]
	},
	avatarRed: {
		backgroundColor: red[100],
		color: red[800]
	},
	avatarBeige: {
		backgroundColor: beige[100],
		color: beige[800]
	},
	groupAvatar: {
		backgroundColor: gray[800],
		color: themeColors.colors.base.white
	},
	optionTitle: {
		fontWeight: 600,
		overflow: "hidden",
		textOverflow: "ellipsis",
		whiteSpace: "nowrap"
	},
	optionSubtitle: {
		color: gray[500]
	},
	attendanceChips: {
		width: "auto",
		flexShrink: 0
	},
	attendanceChip: {
		maxWidth: 170,
		height: 22,
		fontSize: 11,
		backgroundColor: gray[50],
		color: gray[700],
		border: `1px solid ${gray[200]}`,
		"& svg": {
			fontSize: 14,
			color: gray[500]
		}
	},
	ownerChip: {
		backgroundColor: purple[50],
		color: purple[700],
		border: `1px solid ${purple[100]}`,
		"& svg": {
			color: purple[600]
		}
	},
	emptyStateText: {
		color: gray[500]
	},
	emptyStateIcon: {
		color: gray[500]
	},
	loadingContainer: {
		minHeight: 160,
		alignItems: "center"
	},
	selectionCounter: {
		color: gray[500]
	}
})

export default useStyles
